import React from 'react';
import { cn } from '@/lib/utils';

interface DailyQuestItemProps {
  icon: string;
  title: string;
  description: string;
  current: number;
  total: number;
  status: 'completed' | 'available';
}

const DailyQuestItem: React.FC<DailyQuestItemProps> = ({
  icon,
  title,
  description,
  current,
  total,
  status
}) => {
  const progressPercentage = (current / total) * 100;

  return (
    <div
      className="w-full bg-white/5 border-white/10 rounded-lg p-3 shadow-md"
    >
      <div className="flex items-center gap-3">
        {/* Ícone */}
        <div className={cn(
          "flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center",
          status === 'completed' ? "bg-green-500/20" : "bg-blue-500/20"
        )}>
          {status === 'completed' ? (
            <span className="text-xl text-green-400">✓</span>
          ) : (
            <span className="text-xl">{icon}</span>
          )}
        </div>

        {/* Conteúdo */}
        <div className="flex-1 text-left min-w-0">
          <h3 className="text-xs font-medium text-white mb-1 truncate">
            {title}
          </h3>
          <p className="text-xs text-white/60 mb-2 line-clamp-1">
            {description}
          </p>

          {/* Barra de progresso */}
          <div className="relative pr-12">
            <div className="h-1 bg-white/10 rounded-full overflow-hidden">
              <div
                className={cn(
                  "h-full transition-all duration-500 ease-out",
                  status === 'completed'
                    ? "bg-luxury-gold"
                    : "bg-blue-500"
                )}
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
            
            {/* Texto de progresso */}
            <div className="absolute right-0 -top-4">
              <span className="text-xs font-medium text-white/60">
                {current}/{total}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyQuestItem;
